<template>
  <div class="edicao-container">
    <!-- TOPO: Dados da locação e locatário -->
    <div class="card edicao-card mb-4">
      <div class="edicao-card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Boleto da Locação</h4>
        <button class="btn-voltar" @click="$router.go(-1)">Voltar</button>
      </div>
      <div class="edicao-card-body">
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <div>
            <span class="badge-campo"><strong>Pasta:</strong> {{ pasta }}</span>
            <span class="mx-2 text-muted">|</span>
            <span class="badge-campo"><strong>Referência do Imóvel:</strong> {{ boleto.loc_referencia || '---' }}</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span v-if="boleto.pago == 1" class="badge-status pago-sim">
              Pago
            </span>
            <span v-else class="badge-status pago-nao">
              Em aberto
            </span>
            <span v-if="boleto.enviado == 1 || boleto.pago == 1" class="badge-status enviado-sim">
              Enviado
            </span>
            <span v-else class="badge-status rascunho">
              Rascunho
            </span>
          </div>
        </div>

        <hr class="separador" />

        <div class="row">
          <div class="col-md-6">
            <p class="mb-1"><strong>Locatário:</strong> {{ boleto.locatario_nome || '---' }}</p>
            <p class="mb-1"><strong>CPF:</strong> {{ boleto.locatario_cpf || '---' }}</p>
          </div>
          <div class="col-md-6">
            <p class="mb-1">
              <strong>Telefone:</strong>
              <a
                v-if="boleto.locatario_telefone1"
                :href="'https://wa.me/55' + boleto.locatario_telefone1.replace(/\D/g, '')"
                target="_blank"
                class="text-decoration-none"
              >
                {{ boleto.locatario_telefone1 }}
              </a>
              <span v-else>---</span>
            </p>
            <p class="mb-1"><strong>E-mail:</strong> {{ boleto.locatario_email || '---' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- INFORMAÇÕES DO BOLETO -->
    <div class="card edicao-card mb-4">
      <div class="edicao-card-header">
        <h5 class="mb-0">Informações do Boleto</h5>
      </div>
      <div class="edicao-card-body">
        <div class="row">
          <div class="col-md-3">
            <label>Valor Aluguel</label>
            <input v-model="boleto.valor_aluguel" @input="formatarMoeda('valor_aluguel')" class="form-control" readonly />
          </div>
          <div class="col-md-2">
            <label>IPTU</label>
            <input v-model="boleto.valor_iptu" @input="formatarMoeda('valor_iptu')" class="form-control" readonly />
          </div>
          <div class="col-md-2">
            <label>S/Fiança</label>
            <input v-model="boleto.valor_fianca" @input="formatarMoeda('valor_fianca')" class="form-control" readonly />
          </div>
          <div class="col-md-2">
            <label>Taxa Boleto</label>
            <input v-model="boleto.valor_taxa_boleto" @input="formatarMoeda('valor_taxa_boleto')" class="form-control" readonly />
          </div>
          <div class="col-md-2">
            <label>Condomínio</label>
            <input v-model="boleto.valor_condominio" @input="formatarMoeda('valor_condominio')" class="form-control" />
          </div>
          <div class="col-md-3">
            <label>Seguro Incêndio</label>
            <input v-model="boleto.valor_seguro" @input="formatarMoeda('valor_seguro')" class="form-control" />
          </div>
          <div class="col-md-3">
            <label>Valor Total</label>
            <input v-model="boleto.valor_total" class="form-control input-destaque" readonly />
          </div>
          <div class="col-md-3">
            <label>Vencimento</label>
            <input type="date" v-model="boleto.vencimento" class="form-control" />
          </div>
          <div class="col-md-3">
            <label>Pago?</label>
            <select v-model="boleto.pago" class="form-control" readonly>
              <option :value="0">Não</option>
              <option :value="1">Sim</option>
            </select>
          </div>
        </div>

        <div class="mt-3">
          <label>Informações Complementares</label>
          <textarea v-model="boleto.info" class="form-control" rows="3"></textarea>
        </div>

        <!-- Campos Dinâmicos (Outros e Descontos) -->
        <div class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <label class="section-subtitle mb-0">Outros Valores</label>
            <button class="btn-adicionar" @click="adicionarItem('outros')">+ Adicionar Novo</button>
          </div>
          <div v-for="(item, index) in outros" :key="'outros-' + index" class="row align-items-center mb-2">
            <div class="col-md-6">
              <input v-model="item.descricao" class="form-control" placeholder="Descrição" />
            </div>
            <div class="col-md-4">
              <input v-model="item.valor" @input="formatarMoedaItem(item, 'valor')" class="form-control" placeholder="Valor" />
            </div>
            <div class="col-md-2 text-right">
              <button class="btn-remover w-100" @click="removerItem('outros', index)">Remover</button>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <label class="section-subtitle mb-0">Descontos</label>
            <button class="btn-remover-ghost" @click="adicionarItem('descontos')">+ Adicionar Novo</button>
          </div>
          <div v-for="(item, index) in descontos" :key="'descontos-' + index" class="row align-items-center mb-2">
            <div class="col-md-6">
              <input v-model="item.descricao" class="form-control" placeholder="Descrição" />
            </div>
            <div class="col-md-4">
              <input v-model="item.valor" @input="formatarMoedaItem(item, 'valor')" class="form-control" placeholder="Valor" />
            </div>
            <div class="col-md-2 text-right">
              <button class="btn-remover w-100" @click="removerItem('descontos', index)">Remover</button>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <label class="section-subtitle">Upload do Boleto (PDF)</label>
          <input type="file" @change="uploadArquivo" accept="application/pdf" class="form-control-file btn-arquivo" />
          <div v-if="boleto.arquivo_pdf" class="mt-3">
            <p><strong>Arquivo atual:</strong> {{ boleto.arquivo_pdf }}</p>
            <div class="pdf-box">
              <iframe
                :src="`${baseUrl}uploads/boletos/${boleto.arquivo_pdf}`"
                width="100%"
                height="400px"
              ></iframe>
            </div>
          </div>
        </div>

        <div class="text-center mt-4">
          <button class="btn-salvar-edit me-2" @click="salvarAlteracoes">Salvar Alterações</button>
          <button class="btn-enviar-email mx-2" @click="abrirPreviewEmail">Enviar Qr code / boleto ao Locatário</button>
          <button class="btn-visualizar-qr mx-2" @click="visualizarQrCode">Visualizar Qr code</button>
          <button v-if="boleto.pago == 0" class="btn-confirmar mx-2" @click="confirmarPagamento">Confirmar Pagamento</button>
        </div>
      </div>
    </div>

    <!-- Modal Visualizar QR Code PIX -->
    <modal name="modal-qr-pix" :adaptive="true" classes="vue-modal-qr" width="440px" height="auto">
      <div class="modal-qr-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">QR Code PIX</h5>
        <button class="modal-qr-close" @click="$modal.hide('modal-qr-pix')" aria-label="Fechar">&times;</button>
      </div>
      <div class="modal-qr-body text-center">
        <label class="modal-qr-label">Escaneie o QR Code para pagamento do boleto:</label>
        <img
          v-if="pixQrCodeUrl"
          :src="pixQrCodeUrl"
          alt="QR Code Pix"
          class="img-fluid shadow modal-qr-img"
        />
        <p v-if="pixBrCode" class="modal-qr-pasta mb-2"><strong>Pasta:</strong> {{ pasta }}</p>
        <div v-if="pixBrCode" class="modal-qr-brcode">
          <textarea class="form-control text-center" rows="3" :value="pixBrCode" readonly></textarea>
          <button class="btn-copiar-qr mt-3" @click="copiarBrCode">Copiar</button>
        </div>
      </div>
    </modal>

    <!-- Modal de prévia do e-mail (QR code / boleto) antes do envio.
         Mesmo padrão do modal de prévia do Repasses.vue: o HTML retornado
         pelo backend é renderizado em um iframe, idêntico ao que será enviado. -->
    <modal
      name="modal-preview-email"
      :adaptive="true"
      classes="vue-modal-preview-email"
      width="820px"
      height="auto"
    >
      <div class="modal-preview-header">
        <h5>Prévia do E-mail — QR code / Boleto</h5>
        <button
          type="button"
          class="modal-preview-close"
          title="Fechar"
          @click="$modal.hide('modal-preview-email')"
        >
          ×
        </button>
      </div>

      <div class="modal-preview-corpo">
        <!-- srcdoc renderiza o HTML do e-mail exatamente como será enviado -->
        <iframe
          v-if="previewHtml"
          :srcdoc="previewHtml"
          class="modal-preview-iframe"
          title="Prévia do e-mail do boleto"
        ></iframe>
      </div>

      <!-- Destinatários da mensagem: locatário sempre; locador apenas se houver e-mail -->
      <div class="modal-preview-destinatarios">
        <span><strong>Para:</strong> {{ previewTo || '---' }}</span>
        <span><strong>Cópia:</strong> {{ previewCc || 'locador sem e-mail cadastrado' }}</span>
      </div>

      <div class="modal-preview-footer">
        <button
          type="button"
          class="btn-cancelar-preview"
          @click="$modal.hide('modal-preview-email')"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-enviar-preview"
          :disabled="enviandoEmail"
          @click="confirmarEnvioEmail(false)"
        >
          {{ enviandoEmail ? 'Enviando...' : 'Enviar ao Locatário' }}
        </button>
        <button
          type="button"
          class="btn-enviar-preview-copia"
          :disabled="enviandoEmail || !previewCc"
          :title="previewCc ? '' : 'Locador sem e-mail cadastrado'"
          @click="confirmarEnvioEmail(true)"
        >
          {{ enviandoEmail ? 'Enviando...' : 'Enviar ao Locatário + cópia ao Locador' }}
        </button>
      </div>
    </modal>

    <!-- Botão de acesso rápido - Buscar Locações -->
    <router-link to="/buscaLocacoes" class="fab-buscar-locacoes" title="Buscar Locações">
      <span class="fab-icone">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </span>
      <span class="fab-texto">Buscar Locações</span>
    </router-link>
</div>

</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      baseUrl: "https://www2.royaljardim.com.br/sistema/",
      pasta: "",
      id: "",
      boleto: {},
      outros: [],
      descontos: [],
      arquivoSelecionado: null,
      total_pix:0.00,
      pixQrCodeUrl: "",
      pixBrCode: "",
      // Estado da prévia do e-mail (modal antes do envio)
      previewHtml: "",
      previewTo: "",
      previewCc: "",
      enviandoEmail: false,
    };
  },
  mounted() {
    this.pasta = this.$route.params.pasta;
    this.id = this.$route.params.id;
    this.carregarBoleto();
  },
  methods: {
    carregarBoleto() {
      axios
        .post(this.baseUrl + "boletos_editar", new URLSearchParams({
          acao: "carregar",
          id: this.id,
        }))
        .then((res) => {
          this.boleto = res.data;

          // Corrige JSON com escapes
          const parseJsonSafe = (txt) => {
            try {
              if (!txt) return [];
              let clean = txt.replace(/\\"/g, '"').replace(/^"|"$/g, "");
              return JSON.parse(clean);
            } catch {
              return [];
            }
          };

          this.outros = parseJsonSafe(res.data.outros);
          this.descontos = parseJsonSafe(res.data.descontos);

          this.formatarTodosCamposMonetarios();
          this.recalcularTotal();
        });
    },
    adicionarItem(tipo) {
      if (tipo === "outros") this.outros.push({ descricao: "", valor: "R$ 0,00" });
      if (tipo === "descontos") this.descontos.push({ descricao: "", valor: "R$ 0,00" });
    },
    removerItem(tipo, index) {
      if (tipo === "outros") this.outros.splice(index, 1);
      if (tipo === "descontos") this.descontos.splice(index, 1);
      this.recalcularTotal();
    },
    formatarMoeda(campo) {
      this.boleto[campo] = this.formatarValor(this.boleto[campo]);
      this.recalcularTotal();
    },
    formatarMoedaItem(obj, prop) {
      obj[prop] = this.formatarValor(obj[prop]);
      this.recalcularTotal();
    },
    formatarValor(v) {
      v = (v || "").toString().replace(/[^\d]/g, "");
      const num = parseFloat(v) / 100 || 0;
      return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  parseMoeda(v) {
  if (v === null || v === undefined || v === "") return 0;

  // Converte para string e remove o símbolo de moeda e espaços
  let valor = v.toString().trim().replace("R$", "").replace(/\s/g, "");

  // Remove pontos de milhar, mas mantém a vírgula decimal
  valor = valor.replace(/\.(?=\d{3}(,|$))/g, "");

  // Substitui vírgula por ponto para conversão numérica
  valor = valor.replace(",", ".");

  const numero = parseFloat(valor);

  // Retorna 0 caso não seja número válido
  return isNaN(numero) ? 0 : numero;
},
    formatarTodosCamposMonetarios() {
      const campos = ["valor_aluguel", "valor_iptu", "valor_fianca", "valor_taxa_boleto", "valor_condominio", "valor_seguro"];
      campos.forEach(c => this.boleto[c] = this.formatarValor(this.boleto[c]));
      this.outros.forEach(o => o.valor = this.formatarValor(o.valor));
      this.descontos.forEach(d => d.valor = this.formatarValor(d.valor));
    },
    recalcularTotal() {
      let total =
        this.parseMoeda(this.boleto.valor_aluguel) +
        this.parseMoeda(this.boleto.valor_iptu) +
        this.parseMoeda(this.boleto.valor_fianca) +
        this.parseMoeda(this.boleto.valor_taxa_boleto) +
        this.parseMoeda(this.boleto.valor_condominio) +
        this.parseMoeda(this.boleto.valor_seguro);

      this.outros.forEach(o => total += this.parseMoeda(o.valor));
      this.descontos.forEach(d => total -= this.parseMoeda(d.valor));

      this.boleto.valor_total = total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      this.total_pix = total;
    },
 salvarAlteracoes() {
  const boletoLimpo = { ...this.boleto };
  const camposMonetarios = [
    "valor_aluguel",
    "valor_iptu",
    "valor_fianca",
    "valor_taxa_boleto",
    "valor_condominio",
    "valor_seguro",
    "valor_total",
  ];

 camposMonetarios.forEach((campo) => {
  boletoLimpo[campo] = this.parseMoeda(this.boleto[campo]);
  console.log(boletoLimpo[campo]);
});

const limparArray = (arr) =>
  arr.map((item) => ({
    descricao: item.descricao,
    //valor: this.parseMoeda(item.valor),
     valor: item.valor,
  }));

  const outrosLimpos = limparArray(this.outros);
  const descontosLimpos = limparArray(this.descontos);

  const form = new FormData();
  form.append("acao", "salvar");
  form.append("id", this.id);

  for (let campo in boletoLimpo) {
    form.append(campo, boletoLimpo[campo]);
  }

  form.append("outros", JSON.stringify(outrosLimpos));
  form.append("descontos", JSON.stringify(descontosLimpos));

  axios.post(this.baseUrl + "boletos_editar", form).then(() => {
    alert("Alterações salvas com sucesso!");
    this.carregarBoleto();
  });
},
    uploadArquivo(e) {
      const arquivo = e.target.files[0];
      const form = new FormData();
      form.append("acao", "upload");
      form.append("id", this.id);
      form.append("arquivo", arquivo);

      axios.post(this.baseUrl + "boletos_editar", form).then(() => {
        alert("Arquivo enviado com sucesso!");
        this.carregarBoleto();
      });
    },
    confirmarPagamento() {
      if (confirm("Deseja confirmar o pagamento deste boleto?")) {
        axios
          .post(this.baseUrl + "boletos_editar", new URLSearchParams({
            acao: "confirmar_pagamento",
            id: this.id,
            pasta: this.pasta,
          }))
          .then((res) => {alert(res.data.mensagem);this.carregarBoleto();});
      }
    },
    // Abre a modal com a prévia do HTML do e-mail (QR code / boleto) para o
    // usuário conferir antes de escolher o destinatário do envio.
    abrirPreviewEmail() {
      // Garante que o total esteja atualizado (inclui outros/descontos)
      this.recalcularTotal();

      axios
        .post(this.baseUrl + "boletos_editar", new URLSearchParams({
          acao: "preview_email",
          id: this.id,
          valor: this.total_pix
        }))
        .then((res) => {
          if (res.data && res.data.html) {
            this.previewHtml = res.data.html;
            this.previewTo = res.data.to || "";
            this.previewCc = res.data.cc || "";
            this.enviandoEmail = false;
            this.$modal.show("modal-preview-email");
          } else {
            alert("Não foi possível carregar a prévia do e-mail.");
          }
        })
        .catch(() => {
          alert("Falha ao carregar a prévia do e-mail. Tente novamente.");
        });
    },
    // Envia o e-mail a partir dos botões da modal: somente ao locatário ou
    // ao locatário com cópia (CC) para o locador (LOC_LOCADOR_EMAIL).
    async confirmarEnvioEmail(comCopiaLocador) {
      if (this.enviandoEmail) return;
      this.enviandoEmail = true;
      try {
        const params = {
          acao: "enviar_email",
          id: this.id,
          valor: this.total_pix
        };
        if (comCopiaLocador) params.copia_locador = "1";

        const res = await axios.post(
          this.baseUrl + "boletos_editar",
          new URLSearchParams(params)
        );
        alert(res.data.mensagem);

        // Fecha a modal apenas quando o envio deu certo; em erro, mantém
        // aberta para o usuário tentar novamente ou trocar a opção de envio
        if (res.data && typeof res.data.mensagem === "string" && res.data.mensagem.indexOf("sucesso") !== -1) {
          this.$modal.hide("modal-preview-email");
          this.limparPreviewEmail();
          this.carregarBoleto();
        }
      } catch (e) {
        console.error("Erro ao enviar e-mail do boleto:", e);
        alert("Erro ao enviar o e-mail. Tente novamente.");
      } finally {
        this.enviandoEmail = false;
      }
    },
    limparPreviewEmail() {
      this.previewHtml = "";
      this.previewTo = "";
      this.previewCc = "";
    },
    visualizarQrCode() {
      // Garante que o total esteja atualizado (inclui outros/descontos)
      this.recalcularTotal();

      const form = new FormData();
      form.append("valor", this.total_pix.toFixed(2));

      axios
        .post(this.baseUrl + "boletos_editar/visualizar_pix", form)
        .then((res) => {
          if (res.data && res.data.type === "qr" && res.data.data) {
            this.pixQrCodeUrl = `data:image/png;base64,${res.data.data}`;
            this.pixBrCode = res.data.brcode || "";
            this.$modal.show("modal-qr-pix");
          } else {
            alert("Erro ao gerar o QR Code. Tente novamente.");
          }
        })
        .catch(() => {
          alert("Falha ao gerar o QR Code. Tente novamente mais tarde.");
        });
    },
    copiarBrCode() {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(this.pixBrCode)
          .then(() => alert("BR Code copiado com sucesso!"))
          .catch(() => this.copiaBrCodeAlternativa());
      } else {
        this.copiaBrCodeAlternativa();
      }
    },
    copiaBrCodeAlternativa() {
      const textarea = document.createElement("textarea");
      textarea.value = this.pixBrCode;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const sucesso = document.execCommand("copy");
        if (sucesso) alert("BR Code copiado com sucesso!");
        else alert("Não foi possível copiar o BR Code.");
      } catch (e) {
        alert("Seu navegador não permite copiar automaticamente.");
      }
      document.body.removeChild(textarea);
    },
  },
};
</script>

<style scoped>
/* ===== Container ===== */
.edicao-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* ===== Cards ===== */
.edicao-card {
  border: 1px solid #e8e4e3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}
.edicao-card-header {
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
}
.edicao-card-header h4,
.edicao-card-header h5 {
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.edicao-card-header h4 { font-size: 17px; }
.edicao-card-header h5 { font-size: 14px; }
.edicao-card-body {
  padding: 20px;
  background: #fff;
}
.badge-campo {
  font-size: 14px;
  color: #555;
}
.section-subtitle {
  color: #4C1C17;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.separador {
  border: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, #4C1C17, transparent);
  margin: 16px 0;
}

/* ===== Labels e Inputs ===== */
.edicao-card label {
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 5px;
}
.edicao-card .form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 9px 12px;
  font-size: 14px;
  transition: all 0.2s;
}
.edicao-card .form-control:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
}
.edicao-card .form-control[readonly] {
  background: #f8f6f5;
  color: #666;
}
.input-destaque {
  background: #4C1C17 !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 16px;
  border: none !important;
  text-align: center;
}

/* ===== Badge Status ===== */
.badge-status {
  display: inline-block;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.pago-sim {
  background: #e8f5e9;
  color: #28a745;
}
.pago-nao {
  background: #ffe5e5;
  color: #dc3545;
}
.enviado-sim {
  background: #e8f5e9;
  color: #28a745;
}
.rascunho {
  background: #fff8e1;
  color: #f59e0b;
}

/* ===== Botões ===== */
.btn-voltar {
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.4);
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-voltar:hover {
  background: rgba(255,255,255,0.25);
  color: #fff;
  border-color: rgba(255,255,255,0.6);
  transform: translateY(-1px);
}

.btn-adicionar {
  background: linear-gradient(135deg, #28a745, #218838);
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);
}
.btn-adicionar:hover {
  background: linear-gradient(135deg, #34ce57, #28a745);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.btn-remover-ghost {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-remover-ghost:hover {
  background: #dc3545;
  color: #fff;
}

.btn-remover {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-remover:hover {
  background: linear-gradient(135deg, #e8616c, #dc3545);
  color: #fff;
  transform: translateY(-1px);
}

.btn-salvar-edit {
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  border: none;
  padding: 12px 28px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(76,28,23,0.3);
}
.btn-salvar-edit:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(76,28,23,0.4);
}

.btn-enviar-email {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: #fff;
  border: none;
  padding: 12px 28px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(212, 160, 23, 0.3);
}
.btn-enviar-email:hover {
  background: linear-gradient(135deg, #e6b422, #d4a017);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(212, 160, 23, 0.4);
}

.btn-confirmar {
  background: linear-gradient(135deg, #28a745, #218838);
  color: #fff;
  border: none;
  padding: 12px 28px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.btn-confirmar:hover {
  background: linear-gradient(135deg, #34ce57, #28a745);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(40, 167, 69, 0.4);
}

.btn-visualizar-qr {
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: #fff;
  border: none;
  padding: 12px 28px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}
.btn-visualizar-qr:hover {
  background: linear-gradient(135deg, #20c997, #17a2b8);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(23, 162, 184, 0.4);
}

/* ===== Upload PDF ===== */
.btn-arquivo {
  display: block;
  padding: 10px;
  border: 1px dashed #4C1C17;
  border-radius: 6px;
  background: #faf6f5;
  color: #4C1C17;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-arquivo:hover {
  background: #f0e8e6;
}
.pdf-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

/* ===== FAB Buscar Locações ===== */
.fab-buscar-locacoes {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  padding: 14px 22px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(76,28,23,0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}
.fab-icone svg {
  width: 24px;
  height: 24px;
}
.fab-texto {
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  transition: all 0.3s ease;
}
.fab-buscar-locacoes:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(76,28,23,0.5);
}
.fab-buscar-locacoes:hover .fab-texto {
  max-width: 140px;
  opacity: 1;
}
.fab-buscar-locacoes::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50px;
  border: 2px solid #4C1C17;
  animation: fabPulse 2s infinite;
}
@keyframes fabPulse {
  0%   { transform: scale(1);   opacity: 0.8; }
  70%  { transform: scale(1.12); opacity: 0; }
  100% { transform: scale(1.12); opacity: 0; }
}

/* ===== Modal QR Code PIX ===== */
.modal-qr-header {
  background: #4C1C17;
  color: #fff;
  padding: 14px 20px;
}
.modal-qr-header h5 {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.modal-qr-close {
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s;
}
.modal-qr-close:hover {
  color: #fff;
}
.modal-qr-body {
  padding: 24px 20px 20px;
  background: #fff;
}
.modal-qr-label {
  display: block;
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 14px;
}
.modal-qr-img {
  max-width: 280px;
  display: block;
  margin: 0 auto 12px;
}
.modal-qr-pasta {
  color: #666;
  font-size: 13px;
  margin-top: 12px;
  margin-bottom: 0;
}
.modal-qr-brcode textarea {
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  resize: none;
}
.btn-copiar-qr {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: #fff;
  border: none;
  padding: 10px 32px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-copiar-qr:hover {
  background: linear-gradient(135deg, #868e96, #6c757d);
  color: #fff;
  transform: translateY(-1px);
}

/* ===== Modal de prévia do e-mail (QR code / boleto) ===== */
.modal-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
}
.modal-preview-header h5 {
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 14px;
  margin: 0;
}
.modal-preview-close {
  background: transparent;
  color: #fff;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s;
}
.modal-preview-close:hover {
  color: #ffc9c0;
}
.modal-preview-corpo {
  padding: 16px;
  background: #f4f1ef;
}
.modal-preview-iframe {
  width: 100%;
  height: 480px;
  border: 1px solid #e5dfdb;
  border-radius: 6px;
  background: #fff;
}
.modal-preview-destinatarios {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 24px;
  padding: 10px 20px;
  font-size: 13px;
  color: #4C1C17;
  background: #fff;
  border-top: 1px solid #e8e4e3;
}
.modal-preview-footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e8e4e3;
  background: #fff;
}
.btn-cancelar-preview {
  background: #6c757d;
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-cancelar-preview:hover {
  background: #5a6268;
  color: #fff;
}
.btn-enviar-preview {
  background: linear-gradient(135deg, #28a745, #218838);
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-enviar-preview:hover:not(:disabled) {
  background: linear-gradient(135deg, #34ce57, #28a745);
  color: #fff;
  transform: translateY(-1px);
}
.btn-enviar-preview-copia {
  background: linear-gradient(135deg, #4C1C17, #7a322a);
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-enviar-preview-copia:hover:not(:disabled) {
  background: linear-gradient(135deg, #7a322a, #4C1C17);
  color: #fff;
  transform: translateY(-1px);
}
.btn-enviar-preview:disabled,
.btn-enviar-preview-copia:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>

<style>
/* Estilos globais para a raiz do modal (vue-js-modal — renderizado fora do componente) */
.vue-modal-qr {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(76, 28, 23, 0.25);
}
/* Raiz do modal de prévia do e-mail (vue-js-modal — fora do escopo do componente) */
.vue-modal-preview-email {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(76, 28, 23, 0.25);
}